import { ComponentStore } from '@ecs/world';
import type { PlatformComponent, StageBounds } from '@game/scenes/characterPrototype/types';
import type { Tuning } from '@game/tuning';
import { clamp } from '@game/scenes/characterPrototype/math';
import { segmentIntersectsRect } from './geometry2d';

export function hasLineOfSight(
	ex: number,
	ey: number,
	px: number,
	py: number,
	platforms: ComponentStore<PlatformComponent>,
	margin: number
) {
	let blocked = false;
	platforms.forEach((p) => {
		if (blocked) return;
		const rx = p.x - margin;
		const ry = p.y - margin;
		const rw = p.width + margin * 2;
		const rh = p.height + margin * 2;
		if (segmentIntersectsRect(ex, ey, px, py, rx, ry, rw, rh)) {
			blocked = true;
		}
	});
	return !blocked;
}

export function findLineOfSightX(
	ex: number,
	ey: number,
	px: number,
	py: number,
	platforms: ComponentStore<PlatformComponent>,
	bounds: StageBounds,
	tuning: Tuning
) {
	const minX = tuning.enemyMarginX;
	const maxX = bounds.width - tuning.enemyMarginX;
	if (hasLineOfSight(ex, ey, px, py, platforms, tuning.enemyLosMargin)) return clamp(ex, minX, maxX);

	const steps = Math.max(1, Math.floor(tuning.enemyLosSearchMax / Math.max(1, tuning.enemyLosSearchStep)));
	for (let i = 1; i <= steps; i += 1) {
		const dx = i * tuning.enemyLosSearchStep;
		const leftX = clamp(ex - dx, minX, maxX);
		const rightX = clamp(ex + dx, minX, maxX);
		if (hasLineOfSight(leftX, ey, px, py, platforms, tuning.enemyLosMargin)) return leftX;
		if (hasLineOfSight(rightX, ey, px, py, platforms, tuning.enemyLosMargin)) return rightX;
	}
	// fallback: drift toward player's x
	return clamp(px, minX, maxX);
}


